module.exports = __webpack_public_path__ + "img/4.8937a263.jpg";